var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01904 28.7505C3.01904 14.8973 14.2492 3.66711 28.1024 3.66711C41.9555 3.66711 53.1857 14.8973 53.1857 28.7505C53.1857 42.6036 41.9555 53.8338 28.1024 53.8338C14.2492 53.8338 3.01904 42.6036 3.01904 28.7505ZM28.1024 7.16711C16.1822 7.16711 6.51904 16.8303 6.51904 28.7505C6.51904 40.6706 16.1822 50.3338 28.1024 50.3338C40.0225 50.3338 49.6857 40.6706 49.6857 28.7505C49.6857 16.8303 40.0225 7.16711 28.1024 7.16711Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1119 13.0004C29.0784 13.0005 29.8619 13.7841 29.8618 14.7506L29.8604 28.0359L39.2404 37.4159C39.9238 38.0993 39.9238 39.2074 39.2404 39.8908C38.557 40.5742 37.449 40.5742 36.7655 39.8908L26.8729 29.9982C26.5447 29.6699 26.3603 29.2247 26.3604 28.7605L26.3618 14.7503C26.3619 13.7838 27.1454 13.0004 28.1119 13.0004Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.933d6e54.svg";
export { ForwardRef as ReactComponent };